import React, { useState } from 'react';
import { MapPinIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
interface RoomBookingProps {
  persona: 'patient' | 'receptionist';
}
const mockRooms = [{
  id: 1,
  name: 'Room 101',
  type: 'Consultation',
  capacity: 2,
  status: 'Available',
  equipment: ['Examination Table', 'ECG Machine']
}, {
  id: 2,
  name: 'Room 102',
  type: 'Consultation',
  capacity: 2,
  status: 'Occupied',
  equipment: ['Examination Table', 'Blood Pressure Monitor']
}, {
  id: 3,
  name: 'Room 103',
  type: 'Procedure',
  capacity: 4,
  status: 'Available',
  equipment: ['Surgical Table', 'Anesthesia Machine', 'Monitors']
}, {
  id: 4,
  name: 'Room 104',
  type: 'Consultation',
  capacity: 2,
  status: 'Available',
  equipment: ['Examination Table', 'Ultrasound Machine']
}, {
  id: 5,
  name: 'Room 105',
  type: 'Emergency',
  capacity: 3,
  status: 'Available',
  equipment: ['Emergency Cart', 'Defibrillator', 'Oxygen Supply']
}];
export function RoomBooking({
  persona
}: RoomBookingProps) {
  const [selectedRoom, setSelectedRoom] = useState<number | null>(null);
  const [bookingDate, setBookingDate] = useState('');
  const [bookingTime, setBookingTime] = useState('');
  const handleBookRoom = () => {
    if (selectedRoom && bookingDate && bookingTime) {
      alert(`Room ${mockRooms.find(r => r.id === selectedRoom)?.name} booked for ${bookingDate} at ${bookingTime}`);
    }
  };
  return <div className="space-y-6" data-id="element-218">
      {/* Room Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-219">
        {mockRooms.map(room => <button key={room.id} onClick={() => room.status === 'Available' && setSelectedRoom(room.id)} disabled={room.status === 'Occupied'} className={`bg-white rounded-lg shadow-sm border-2 p-6 text-left transition-all ${room.status === 'Occupied' ? 'opacity-50 cursor-not-allowed border-gray-200' : selectedRoom === room.id ? 'border-blue-600 shadow-md' : 'border-gray-200 hover:border-gray-300 hover:shadow-md'}`} data-id="element-220">
            <div className="flex items-start justify-between mb-4" data-id="element-221">
              <div className="flex items-center space-x-2" data-id="element-222">
                <MapPinIcon className="w-5 h-5 text-blue-600" data-id="element-223" />
                <h3 className="font-semibold text-gray-900" data-id="element-224">{room.name}</h3>
              </div>
              {room.status === 'Available' ? <CheckCircleIcon className="w-5 h-5 text-green-600" data-id="element-225" /> : <XCircleIcon className="w-5 h-5 text-red-600" data-id="element-226" />}
            </div>
            <div className="space-y-2 mb-4" data-id="element-227">
              <div className="text-sm" data-id="element-228">
                <span className="text-gray-600" data-id="element-229">Type:</span>
                <span className="ml-2 font-medium text-gray-900" data-id="element-230">
                  {room.type}
                </span>
              </div>
              <div className="text-sm" data-id="element-231">
                <span className="text-gray-600" data-id="element-232">Capacity:</span>
                <span className="ml-2 font-medium text-gray-900" data-id="element-233">
                  {room.capacity} people
                </span>
              </div>
              <div className="text-sm" data-id="element-234">
                <span className="text-gray-600" data-id="element-235">Status:</span>
                <span className={`ml-2 px-2 py-1 text-xs font-medium rounded-full ${room.status === 'Available' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-236">
                  {room.status}
                </span>
              </div>
            </div>
            <div data-id="element-237">
              <div className="text-xs text-gray-600 mb-1" data-id="element-238">Equipment:</div>
              <div className="flex flex-wrap gap-1" data-id="element-239">
                {room.equipment.map((item, idx) => <span key={idx} className="px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded" data-id="element-240">
                    {item}
                  </span>)}
              </div>
            </div>
          </button>)}
      </div>
      {/* Booking Form */}
      {selectedRoom && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-241">
          <h2 className="text-xl font-bold mb-4" data-id="element-242">
            Book {mockRooms.find(r => r.id === selectedRoom)?.name}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-243">
            <div data-id="element-244">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-245">
                Date
              </label>
              <input type="date" value={bookingDate} onChange={e => setBookingDate(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-246" />
            </div>
            <div data-id="element-247">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-248">
                Time
              </label>
              <input type="time" value={bookingTime} onChange={e => setBookingTime(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-249" />
            </div>
          </div>
          <div className="flex justify-end space-x-4" data-id="element-250">
            <button onClick={() => setSelectedRoom(null)} className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50" data-id="element-251">
              Cancel
            </button>
            <button onClick={handleBookRoom} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-252">
              Confirm Booking
            </button>
          </div>
        </div>}
    </div>;
}